import React from 'react';
import { Platform, View, StyleSheet } from 'react-native';
import { Text, Button, TextInput } from 'react-native-paper';
import DateTimePicker from '@react-native-community/datetimepicker';

// Web platformu için bir DateTimePicker alternatifi
const WebDateTimePicker = ({ 
  value, 
  onChange, 
  mode = 'date',
  display = 'default',
  label = 'Tarih Seçin',
  placeholder = 'GG/AA/YYYY'
}) => {
  // Platform kontrolü
  if (Platform.OS === 'web') {
    // Web için alternatif tarih girişi
    const formatDate = (date) => {
      if (!date) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      if (mode === 'date') {
        return `${day}/${month}/${year}`;
      } else if (mode === 'time') {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      }
      return `${day}/${month}/${year}`;
    };
    
    // Web için tarih alanı
    return (
      <View style={styles.container}>
        <Text style={styles.label}>{label}</Text>
        <input
          type={mode}
          value={value ? value.toISOString().split('T')[0] : ''}
          onChange={(e) => {
            // Değişikliği iOS/Android formatında geri bildir
            const selectedDate = new Date(e.target.value);
            onChange({ type: 'set', nativeEvent: { timestamp: selectedDate.getTime() } });
          }}
          style={styles.webInput}
        />
      </View>
    );
  }
  
  // Native platformlar için normal DateTimePicker
  return (
    <DateTimePicker
      value={value || new Date()}
      mode={mode}
      display={display}
      onChange={onChange}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
  },
  label: {
    marginBottom: 4,
    fontSize: 14,
  },
  webInput: {
    padding: 8,
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    fontSize: 16,
    backgroundColor: '#fff',
    width: '100%',
    maxWidth: 300,
  }
});

export default WebDateTimePicker;
